import SystemTooltip from "../SystemTooltip";
import useTooltipsControl from "@hooks/useTooltipsControl";
import { SystemsMapProps } from "../models/SystemIconData";

/* eslint-disable @next/next/no-img-element */
const PiemonteSystemsMap = ({ iconsData }: SystemsMapProps) => {
  const { toggle, opened } = useTooltipsControl();
  const openFirst = () => toggle("1");
  const openSecond = () => toggle("2");
  const openThird = () => toggle("3");
  const openFourth = () => toggle("4");
  const openFifth = () => toggle("5");
  const openSixth = () => toggle("6");

  return (
    <svg
      viewBox="0 0 376 480"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      id="piemonteDetail"
    >
      <path
        d="M311.462 76.725L313.947 76.9502L314.986 76.4097L317.246 74.5177L318.15 74.1573L318.873 74.4726L319.054 87.176L318.963 88.3473L318.737 89.7438L317.969 92.1763L317.427 93.3476L316.839 94.2035L297.678 112.673L297.272 113.214L296.955 114.115V115.646L297.091 118.844L297.904 122.719L298.266 128.845L298.13 130.106L297.814 130.782L297.543 131.413L297.136 132.043L296.729 132.584L293.611 135.062L293.204 135.557L292.798 136.143L292.527 136.773L292.843 138.665L293.792 141.503L296.684 147.72L298.085 150.198L299.215 151.639L302.152 152.54L303.237 153.261L303.644 153.982L303.915 155.018L303.779 157L303.508 158.171L302.966 159.793V160.649L303.282 161.46L304.141 162.27L304.909 162.451L306.355 162.27L306.943 162.541L307.168 163.261L307.033 164.703V165.829L307.168 166.955L307.62 168.217V169.118L307.033 169.974L306.355 170.064H305.677H305.09L304.999 170.784L305.496 172.181L309.112 176.911L309.383 177.722L309.564 178.668L309.021 182.362L310.332 184.209L310.015 186.191L310.106 187.227L310.422 188.623L311.145 190.876L311.416 192.272V194.209L311.959 195.2L312.772 196.462L315.755 199.029L318.557 200.155L319.144 200.516L319.957 201.957L320.906 204.255L324.07 214.3L324.431 215.111L326.917 218.4L317.11 221.553L312.591 224.481L312.501 225.202L312.998 225.652L314.76 226.733L315.258 227.184L315.574 227.725V228.4L315.348 228.986L314.76 229.481L310.693 231.644L309.699 232.5L309.247 232.995L308.841 233.626L308.524 234.301L308.298 235.067L307.846 237.545L307.62 238.266L307.259 238.761L306.491 238.851L305.361 238.671L302.785 237.68L301.746 236.869L301.022 236.058L298.989 230.833L298.401 229.617L297.678 228.445L297.226 227.95L296.639 227.544L295.374 226.959L289.092 225.202L286.833 225.112L285.974 225.247L285.341 225.517L284.663 226.418L283.94 227.815L282.901 230.968L281.681 233.851L279.738 235.923L278.924 237.41L277.975 238.761L277.749 239.257V239.977L277.885 240.878L278.698 241.824L279.421 242.365L280.009 243.176L280.28 244.347V248.221L281.003 249.482L281.681 249.978L282.223 250.609L282.449 251.329L282.042 252.771L281.907 253.987L282.087 255.429L283.308 257.591L284.211 258.582L284.98 259.303L285.296 260.024L285.477 260.609L284.211 263.492L284.528 265.339L284.799 266.375L285.658 268.222L285.929 268.538L286.968 272.141L291.668 278.358L294.741 288.133L296.503 292.278L299.757 295.791L301.746 294.53L303.463 294.755L306.174 296.062L311.688 296.287L315.077 295.836L323.934 290.971L326.42 290.025L330.397 291.152L330.803 291.422V292.548L329.809 297.638L329.719 298.539V299.35L329.899 300.116L330.035 300.792L330.216 301.377L330.487 302.008L330.758 302.323L332.746 303.81L333.695 304.35L334.645 304.711L338.938 305.251L340.158 305.747L341.152 306.468L341.423 306.693L342.101 307.549L342.553 308.315L342.96 309.351L343.276 311.288L343.186 312.414L342.734 314.081L343.05 315.162L343.728 316.378L346.349 319.622L353.896 327.009L354.303 327.595L354.574 328.406V329.667L354.257 330.433L353.534 331.739L353.354 332.55L353.218 333.361L353.308 334.127L353.851 335.253L354.8 336.605L357.059 339.262L358.415 340.208L359.545 340.704L363.07 340.839L366.368 341.47L367.001 341.785L367.543 342.145L368.041 342.596L368.583 343.407L369.17 344.488L370.571 347.821L372.831 355.975L373.554 357.507L374.096 358.453L374.548 358.903L375 361.246L374.006 369.129L373.689 383.139L372.966 386.067L371.837 387.373L369.939 388.454L368.538 389.04L366.278 389.49H365.419L363.386 388.905L361.443 388.004L360.72 387.553L360.132 387.013L359.725 386.517L359.5 385.887L359.409 385.076V383.319L358.505 382.283L357.059 381.292L350.145 378.364L348.202 376.562L346.213 373.814L344.27 372.417L341.83 371.156L340.7 370.39L339.887 369.715L338.667 367.552L337.763 367.147L336.543 367.057L333.379 367.327L332.566 367.642L332.159 368.093L331.933 368.498L331.12 371.111L330.894 371.652L330.668 372.012L328.996 373.724L326.375 375.796L326.058 376.337L325.923 376.967L326.103 377.553L326.555 378.003L328.273 379.129L329.719 380.481L330.08 381.067L330.351 381.742L330.487 382.463V383.319L330.442 386.067V387.779V388.635L330.351 389.49L330.08 390.391L329.538 391.247L328.318 392.193L327.459 392.373L324.522 391.788L320.861 391.563L319.189 391.698L318.059 392.103L317.743 392.689L316.839 395.707L316.523 396.428L316.207 397.013L315.8 397.554L315.303 397.959L313.043 399.491L312.637 399.987L311.823 401.338L310.377 403.185L309.925 403.545H309.564L309.157 403.365L308.841 402.825L308.66 402.149V401.338L309.202 399.086L309.112 398.32L308.886 397.644L307.846 396.022L307.168 394.761L306.445 392.779L305.27 391.157L304.638 389.851L304.141 388.499L303.87 387.869L303.463 387.328L302.649 386.833L301.474 386.427L289.996 384.625H288.369L287.149 384.76L286.607 385.166L286.245 385.706L285.658 387.103L285.432 387.779L284.844 389.13L284.618 389.851L284.528 390.527L284.709 391.202L284.935 391.788L285.07 392.509L284.98 393.184L284.709 393.815L284.347 394.446L283.172 396.157L281.997 397.374L279.286 398.995L266.451 398.004L262.339 398.41L260.803 399.041H259.628L258.588 398.725L257.368 398.004H256.6L255.922 398.23L253.753 399.716L253.301 400.122L252.939 400.527L252.668 400.842L252.397 401.473L252.171 402.104L251.584 402.915L250.77 403.725L249.008 404.762H248.059L247.426 404.446L247.065 403.861L246.703 403.365L246.251 402.87L245.031 402.194L242.319 401.158L241.642 400.752L240.557 399.851L239.201 398.455L236.942 397.013L235.902 396.112L234.953 394.581L233.507 392.959L231.474 393.319L229.079 396.112L228.672 396.833L227.542 399.311L226.774 401.518L225.463 403.455L224.921 404.762L224.695 405.798L224.785 406.609L225.011 407.284L225.373 407.87L226.232 408.861L226.638 409.672L226.909 410.798V413.005L226.503 414.312L225.915 415.528L224.74 417.105L224.198 417.6L223.656 418.006L223.159 418.321L220.899 418.861L220.312 419.087L219.543 419.943L218.73 421.114L216.922 424.312L216.29 426.249L215.792 428.366L215.386 429.177L214.843 429.763L211.951 431.565L210.912 432.556L209.827 433.997L208.878 435.034L207.794 435.799L206.122 436.475L205.037 437.196L204.63 437.917V438.637L204.947 439.178L205.444 439.628L205.715 440.664V442.106L204.404 447.016L204.133 448.368V449.178L204.269 449.944L204.359 451.025L204.269 452.377L203.726 454.629V455.891L203.998 456.746L204.54 457.197L204.947 457.918L205.218 458.909L205.127 460.846L204.856 461.927L204.449 462.828L202.913 465.08L201.241 467.152L200.292 467.873L199.885 468.053L199.388 468.189H198.665L197.264 467.783L195.276 466.882L193.83 466.567L192.926 466.792L192.203 467.333L190.757 468.864L190.169 469.945L189.943 470.982L190.124 471.702L190.531 472.243L191.118 472.648L192.248 473.234L192.564 473.594L192.835 474.18V475.306L192.7 475.937L192.384 476.387L191.57 476.748L190.531 476.928L180.408 475.126L177.651 474.09L168.071 473.144L164.139 472.198L163.687 471.702L161.744 470.351L159.394 469.135L158.038 468.774H156.999L156.366 468.999L155.779 469.315L154.739 470.171L154.288 470.666L153.067 472.468L152.751 473.054L152.525 473.729L152.39 474.45V475.171L152.616 475.847L152.977 476.387L153.519 476.793V477.243V477.649L149.181 479H146.018L144.481 475.081L141.408 471.612L139.826 467.693L142.267 461.161L137.748 460.08L131.466 463.684L127.173 463.774L101.143 469.63L95.223 469.135L93.8673 468.729L92.5568 467.288L91.8789 465.531L90.9751 463.999L89.0771 463.098L85.3262 462.242L82.6148 460.891L67.6114 450.305L61.8722 447.737L53.557 442.556L51.7494 441.926H49.761L47.9534 442.466L46.1909 442.647L44.2929 441.701L43.0275 440.034L42.4853 438.187L42.1237 436.25L41.3555 434.178L40.1353 432.511L37.3787 430.213L36.1585 428.772L35.4355 427.15L33.9894 422.871L32.95 420.753L29.9674 416.744L29.4703 415.798L29.0636 413.906L29.1539 412.87L29.5607 411.654L31.2327 405.347L32.4077 403.635L37.4691 401.248L33.8538 397.779L29.7414 392.779L26.8492 386.833V380.436L28.5665 377.823L36.3845 372.598L42.0333 364.264L44.1573 362.867L42.8016 358.408L44.1121 354.308L47.0043 351.155L50.484 349.533L53.1503 349.668L58.3021 351.56L60.878 351.65L60.2001 348.948L56.3137 340.253L55.907 338.452L55.455 333.361L54.0993 328.856L54.2349 328.631L55.1839 325.433L55.455 325.298V324.352L55.6358 323.811L55.7262 323.18L55.455 321.964L54.9128 320.883L52.5176 317.865L45.4227 314.351L42.892 313.991L35.6162 314.937L32.9048 314.036L23.3243 307.504L18.8504 303.044L16.5909 298.584L17.7206 287.187L17.2235 281.241L13.6083 278.223L8.54688 277.367L7.10077 275.971L5.56428 272.817L5.33833 270.97L5.60947 269.349L5.4739 267.862L3.25955 265.655L1 261.6L2.85283 259.393L5.02199 257.816L5.65466 257.366L10.8968 254.888L12.2073 254.708L14.7832 254.978L15.9582 254.888L17.2235 254.258L19.9802 252.411L21.1551 251.96L26.1713 253.176L31.2779 256.42L36.3393 258.582L41.1747 256.6L41.5362 255.384L40.768 254.393L40.1805 253.221L41.0843 251.51L42.2593 251.059L45.6034 251.239L46.9592 251.014L49.2187 249.212L52.0205 244.978L54.0089 243.311L59.3415 241.284L64.4932 240.203L65.623 240.788L67.2951 243.086L68.0181 243.401L69.0575 242.455L72.1305 237.59L76.2881 234.572L76.4688 231.373L75.2035 227.139L74.8871 221.193L75.7006 220.021L80.762 214.796L84.1061 209.66L85.5522 206.597L85.9137 204.075L84.8743 203.129L78.9091 200.065L77.0563 198.444L76.0621 196.101L75.2487 193.488L74.4804 192.047L76.6044 189.975L83.1571 183.623L84.1061 183.308L84.8743 183.217L84.7388 183.893L84.1061 185.65V185.83V186.191L84.2868 186.686L84.6484 187.092L85.0551 187.362L87.4954 188.263L94.4548 189.659H96.2172L97.4374 189.479L98.4316 188.668L119.897 182.902L120.44 182.542L122.383 180.695L122.925 180.334L125.998 178.803L126.992 177.902L128.845 175.92L131.918 173.397L132.957 172.947L134.087 172.766L136.708 173.082L138.019 172.857L139.329 172.406L141.363 171.37L142.673 171.055L143.803 170.965L157.451 174.839L158.129 175.154L158.716 175.514L160.343 176.866L161.699 177.361L170.059 178.217L171.551 178.082L172.68 177.857L173.9 177.226L177.877 174.613L191.932 171.01L196.993 164.478L198.123 161.865V161.054L197.852 160.378L197.219 159.162L197.129 157.36L197.264 154.612L198.349 148.08L198.529 145.332L198.439 143.576L197.987 143.08L195.095 141.323L193.92 140.287L193.558 139.792L193.197 139.071L192.971 138.125L192.564 134.566L192.338 133.53L191.841 129.25L191.977 125.872L191.886 119.971L190.757 108.303L190.847 106.817L191.073 106.276L192.067 106.006L191.389 101.681L194.869 95.9153L198.801 93.4827L209.014 91.7258L210.415 91.4105L211.499 90.5997L213.397 88.3923L213.488 87.9418L215.069 84.9687L215.386 84.5633L216.47 78.7972L216.606 76.4998L217.013 74.1573L218.142 72.1301L219.634 71.1391L222.616 70.9589L224.198 70.5535L230.751 65.4631L234.185 59.0213V51.4533L230.434 43.1645L227.316 40.0563L226.864 39.2454L227.587 37.5786L229.124 35.6416L232.061 32.9387L235.225 31.6774L241.461 30.6413L244.489 28.7493L251.99 19.92L256.103 18.1181L257.775 16.9468L259.266 15.3251L260.215 13.4782V11.406L259.356 10.6402L258.859 9.78428L260.17 7.26161L263.378 4.19837L267.31 2.30638L273.456 1.31533L275.309 1L279.376 1.90095L281.138 4.82904L281.5 9.46894L281.229 15.6405L280.461 21.5417L277.659 31.9927L276.936 37.2633L277.207 42.2636L278.608 45.6422L281.093 47.8945L284.754 49.5613L288.55 51.7236L292.391 56.0482L300.706 69.6976L302.062 70.5084L304.773 71.5896L311.236 75.779L311.462 76.725Z"
        fill="#001A70"
        stroke="#84B5E7"
        strokeMiterlimit="10"
      />

      <SystemTooltip
        className="system-tooltip"
        open={opened === "1"}
        closeTooltip={toggle}
        href={iconsData?.at(0)?.href}
        title={iconsData?.at(0)?.label || "Title"}
      >
        <g onMouseEnter={openFirst} onClick={openFirst}>
          <path
            d="M135.952 272.809V288.047"
            stroke="white"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M141.032 272.809V288.047"
            stroke="white"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M135.952 288.047H141.032"
            stroke="white"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M135.952 272.809H141.032"
            stroke="white"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M174.048 272.809V288.047"
            stroke="white"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M168.968 288.047H174.048"
            stroke="white"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M168.968 272.809V288.047"
            stroke="white"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M174.048 272.809H168.968"
            stroke="white"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M141.032 285.508H168.968"
            stroke="white"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M141.032 275.35H151.19"
            stroke="white"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M168.968 275.35H158.81"
            stroke="white"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M151.19 272.809V275.348"
            stroke="white"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M158.81 272.809V275.348"
            stroke="white"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M151.19 272.809H158.809"
            stroke="white"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M155 267.731C159.909 267.731 163.889 263.751 163.889 258.842C163.889 253.933 159.909 249.953 155 249.953C150.091 249.953 146.111 253.933 146.111 258.842C146.111 263.751 150.091 267.731 155 267.731Z"
            stroke="white"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M155 258.842L158.592 255.25"
            stroke="white"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M152.46 272.809V267.361"
            stroke="white"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M157.54 272.809V267.361"
            stroke="white"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
      </SystemTooltip>

      <SystemTooltip
        className="system-tooltip"
        open={opened === "2"}
        closeTooltip={toggle}
        href={iconsData?.at(1)?.href}
        title={iconsData?.at(1)?.label || "Title"}
      >
        <g onMouseEnter={openSecond} onClick={openSecond}>
          <path
            d="M75.9521 398.809V414.047"
            stroke="white"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M81.0317 398.809V414.047"
            stroke="white"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M75.9521 414.047H81.0315"
            stroke="white"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M75.9521 398.809H81.0315"
            stroke="white"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M114.048 398.809V414.047"
            stroke="white"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M108.968 414.047H114.048"
            stroke="white"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M108.968 398.809V414.047"
            stroke="white"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M114.048 398.809H108.968"
            stroke="white"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M81.0317 411.508H108.968"
            stroke="white"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M81.0317 401.35H91.1905"
            stroke="white"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M108.968 401.35H98.8096"
            stroke="white"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M91.1904 398.809V401.348"
            stroke="white"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M98.8096 398.809V401.348"
            stroke="white"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M91.1904 398.809H98.8095"
            stroke="white"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M95.0002 393.731C99.9094 393.731 103.889 389.751 103.889 384.842C103.889 379.933 99.9094 375.953 95.0002 375.953C90.091 375.953 86.1113 379.933 86.1113 384.842C86.1113 389.751 90.091 393.731 95.0002 393.731Z"
            stroke="white"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M95 384.842L98.592 381.25"
            stroke="white"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M92.4604 398.809V393.361"
            stroke="white"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M97.5396 398.809V393.361"
            stroke="white"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
      </SystemTooltip>

      <SystemTooltip
        className="system-tooltip"
        open={opened === "3"}
        closeTooltip={toggle}
        href={iconsData?.at(2)?.href}
        title={iconsData?.at(2)?.label || "Title"}
      >
        <g onMouseEnter={openThird} onClick={openThird}>
          <path
            d="M115.952 373.809V389.047"
            stroke="white"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M121.032 373.809V389.047"
            stroke="white"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M115.952 389.047H121.032"
            stroke="white"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M115.952 373.809H121.032"
            stroke="white"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M154.048 373.809V389.047"
            stroke="white"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M148.968 389.047H154.048"
            stroke="white"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M148.968 373.809V389.047"
            stroke="white"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M154.048 373.809H148.968"
            stroke="white"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M121.032 386.508H148.968"
            stroke="white"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M121.032 376.35H131.19"
            stroke="white"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M148.968 376.35H138.81"
            stroke="white"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M131.19 373.809V376.348"
            stroke="white"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M138.81 373.809V376.348"
            stroke="white"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M131.19 373.809H138.809"
            stroke="white"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M135 368.731C139.909 368.731 143.889 364.751 143.889 359.842C143.889 354.933 139.909 350.953 135 350.953C130.091 350.953 126.111 354.933 126.111 359.842C126.111 364.751 130.091 368.731 135 368.731Z"
            stroke="white"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M135 359.842L138.592 356.25"
            stroke="white"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M132.46 373.809V368.361"
            stroke="white"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M137.54 373.809V368.361"
            stroke="white"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
      </SystemTooltip>

      <SystemTooltip
        className="system-tooltip"
        open={opened === "4"}
        closeTooltip={toggle}
        href={iconsData?.at(3)?.href}
        title={iconsData?.at(3)?.label || "Title"}
      >
        <g onMouseEnter={openFourth} onClick={openFourth}>
          <path
            d="M111.952 426.809V442.047"
            stroke="white"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M117.032 426.809V442.047"
            stroke="white"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M111.952 442.047H117.032"
            stroke="white"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M111.952 426.809H117.032"
            stroke="white"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M150.048 426.809V442.047"
            stroke="white"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M144.968 442.047H150.048"
            stroke="white"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M144.968 426.809V442.047"
            stroke="white"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M150.048 426.809H144.968"
            stroke="white"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M117.032 439.508H144.968"
            stroke="white"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M117.032 429.35H127.19"
            stroke="white"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M144.968 429.35H134.81"
            stroke="white"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M127.19 426.809V429.348"
            stroke="white"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M134.81 426.809V429.348"
            stroke="white"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M127.19 426.809H134.809"
            stroke="white"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M131 421.731C135.909 421.731 139.889 417.751 139.889 412.842C139.889 407.933 135.909 403.953 131 403.953C126.091 403.953 122.111 407.933 122.111 412.842C122.111 417.751 126.091 421.731 131 421.731Z"
            stroke="white"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M131 412.842L134.592 409.25"
            stroke="white"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M128.46 426.809V421.361"
            stroke="white"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M133.54 426.809V421.361"
            stroke="white"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
      </SystemTooltip>

      <SystemTooltip
        className="system-tooltip"
        open={opened === "5"}
        closeTooltip={toggle}
        href={iconsData?.at(4)?.href}
        title={iconsData?.at(4)?.label || "Title"}
      >
        <g onMouseEnter={openFifth} onClick={openFifth}>
          <path
            d="M148.952 403.809V419.047"
            stroke="white"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M154.032 403.809V419.047"
            stroke="white"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M148.952 419.047H154.032"
            stroke="white"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M148.952 403.809H154.032"
            stroke="white"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M187.048 403.809V419.047"
            stroke="white"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M181.968 419.047H187.048"
            stroke="white"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M181.968 403.809V419.047"
            stroke="white"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M187.048 403.809H181.968"
            stroke="white"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M154.032 416.508H181.968"
            stroke="white"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M154.032 406.35H164.19"
            stroke="white"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M181.968 406.35H171.81"
            stroke="white"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M164.19 403.809V406.348"
            stroke="white"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M171.81 403.809V406.348"
            stroke="white"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M164.19 403.809H171.809"
            stroke="white"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M168 398.731C172.909 398.731 176.889 394.751 176.889 389.842C176.889 384.933 172.909 380.953 168 380.953C163.091 380.953 159.111 384.933 159.111 389.842C159.111 394.751 163.091 398.731 168 398.731Z"
            stroke="white"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M168 389.842L171.592 386.25"
            stroke="white"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M165.46 403.809V398.361"
            stroke="white"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M170.54 403.809V398.361"
            stroke="white"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
      </SystemTooltip>

      <SystemTooltip
        className="system-tooltip"
        open={opened === "6"}
        closeTooltip={toggle}
        href={iconsData?.at(5)?.href}
        title={iconsData?.at(5)?.label || "Title"}
      >
        <g onMouseEnter={openSixth} onClick={openSixth}>
          <path
            d="M95.9521 296.809V312.047"
            stroke="white"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M101.032 296.809V312.047"
            stroke="white"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M95.9521 312.047H101.032"
            stroke="white"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M95.9521 296.809H101.032"
            stroke="white"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M134.048 296.809V312.047"
            stroke="white"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M128.968 312.047H134.048"
            stroke="white"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M128.968 296.809V312.047"
            stroke="white"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M134.048 296.809H128.968"
            stroke="white"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M101.032 309.508H128.968"
            stroke="white"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M101.032 299.35H111.19"
            stroke="white"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M128.968 299.35H118.81"
            stroke="white"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M111.19 296.809V299.348"
            stroke="white"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M118.81 296.809V299.348"
            stroke="white"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M111.19 296.809H118.809"
            stroke="white"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M115 291.731C119.909 291.731 123.889 287.751 123.889 282.842C123.889 277.933 119.909 273.953 115 273.953C110.091 273.953 106.111 277.933 106.111 282.842C106.111 287.751 110.091 291.731 115 291.731Z"
            stroke="white"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M115 282.842L118.592 279.25"
            stroke="white"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M112.46 296.809V291.361"
            stroke="white"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M117.54 296.809V291.361"
            stroke="white"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
      </SystemTooltip>

      <defs>
        <clipPath id="clip5_518_6869">
          <rect
            width="40"
            height="40"
            fill="white"
            transform="translate(135 249)"
          />
        </clipPath>
        <clipPath id="clip1_518_6869">
          <rect
            width="40"
            height="40"
            fill="white"
            transform="translate(75 375)"
          />
        </clipPath>
        <clipPath id="clip2_518_6869">
          <rect
            width="40"
            height="40"
            fill="white"
            transform="translate(115 350)"
          />
        </clipPath>
        <clipPath id="clip3_518_6869">
          <rect
            width="40"
            height="40"
            fill="white"
            transform="translate(111 403)"
          />
        </clipPath>
        <clipPath id="clip4_518_6869">
          <rect
            width="40"
            height="40"
            fill="white"
            transform="translate(148 380)"
          />
        </clipPath>
        <clipPath id="clip0_518_6869">
          <rect
            width="40"
            height="40"
            fill="white"
            transform="translate(95 273)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export default PiemonteSystemsMap;
